var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textBox"},[_c('label',{attrs:{"for":"textBox-01"}},[_vm._v(_vm._s(_vm.text))]),_c('input',{style:(`width:${_vm.width}px;`),attrs:{"id":"textBox-01","type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.updateValue}})])
}
var staticRenderFns = []

export { render, staticRenderFns }